exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Archive-local__myMedias--3WVaS {\n  padding-top: 8.625rem;\n  background-color: #29394e; }\n\n.Archive-local__header--3Zujb {\n  padding: 0 1.325rem;\n  height: 15rem;\n  background: url(\"/img/archive.jpg\") no-repeat;\n  background-position: center;\n  background-size: cover;\n  margin-bottom: 3.5rem;\n  position: relative; }\n\n.Archive-local__body--1qz9l {\n  padding: 0 5.125rem; }\n\n.Archive-local__medias--1gB6y {\n  padding: 2rem 0; }\n\n.Archive-local__tabs--IHU91 {\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  bottom: -45px;\n  width: 100%;\n  -ms-flex-pack: center;\n      justify-content: center;\n  margin-bottom: 20px; }\n  .Archive-local__tabs--IHU91 button {\n    margin: 0 10px;\n    padding: 15px 60px;\n    text-transform: uppercase; }\n", ""]);

// exports
exports.locals = {
	"myMedias": "Archive-local__myMedias--3WVaS",
	"header": "Archive-local__header--3Zujb",
	"body": "Archive-local__body--1qz9l",
	"medias": "Archive-local__medias--1gB6y",
	"tabs": "Archive-local__tabs--IHU91"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/media/media/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/Archive/Archive.local.scss
// module id = 525
// module chunks = 0